import React from 'react';
import { AppIcon } from '../icons/AppIcon';

export interface QuantityCounterProps {
    value: number;
    onChange: (value: number) => void;
    min?: number;
    max?: number;
    disabled?: boolean;
    className?: string;
}

const QuantityCounter: React.FC<QuantityCounterProps> = ({
    value,
    onChange,
    min = 1,
    max = 999,
    disabled = false,
    className = '',
}) => {
    const canDecrease = value > min && !disabled;
    const canIncrease = value < max && !disabled;

    const handleDecrease = () => {
        if (canDecrease) onChange(value - 1);
    };

    const handleIncrease = () => {
        if (canIncrease) onChange(value + 1);
    };

    return (
        <div className={`inline-flex items-center ${className}`}>
            {/* Botão diminuir */}
            <button
                type="button"
                onClick={handleDecrease}
                disabled={!canDecrease}
                className={`
                    w-11 h-11 flex items-center justify-center
                    border border-gray-300 rounded-l-md bg-white
                    transition-colors duration-150
                    ${canDecrease
                        ? 'hover:bg-gray-50 text-gray-700'
                        : 'text-gray-300 cursor-not-allowed'}
                `}
                aria-label="Diminuir"
            >
                <AppIcon name="minus" className="w-4 h-4" />
            </button>

            {/* Campo de valor */}
            <div className="w-16 h-11 flex items-center justify-center border-t border-b border-gray-300 bg-white">
                <span className="text-lg font-semibold text-gray-900 tabular-nums">
                    {value}
                </span>
            </div>

            {/* Botão aumentar */}
            <button
                type="button"
                onClick={handleIncrease}
                disabled={!canIncrease}
                className={`
                    w-11 h-11 flex items-center justify-center
                    border border-gray-300 rounded-r-md bg-white
                    transition-colors duration-150
                    ${canIncrease
                        ? 'hover:bg-gray-50 text-gray-700'
                        : 'text-gray-300 cursor-not-allowed'}
                `}
                aria-label="Aumentar"
            >
                <AppIcon name="plus" className="w-4 h-4" />
            </button>
        </div>
    );
};

export default QuantityCounter;
